import { render, staticRenderFns } from "./wxwl-usa.vue?vue&type=template&id=60d79a5a"
import script from "./wxwl-usa.vue?vue&type=script&lang=js"
export * from "./wxwl-usa.vue?vue&type=script&lang=js"
import style0 from "./wxwl-usa.vue?vue&type=style&index=0&id=60d79a5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports